<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { ModalDefault } from '@shared/ui/modals'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useModalDeleteApiToken } from '../../../model/api-tokens/modals/modal-delete-api-token.hook'

defineOptions({
  name: 'ModalDeleteApiToken',
})

const {
  refIsOpen,
  refIsLoading,
  refToken,
  closeModal,
  confirmDelete,
} = useModalDeleteApiToken()
</script>

<template>
  <ModalDefault
    :show="refIsOpen"
    :loading="refIsLoading"
    title="Revoke API token"
    is-close-button
    @click:overlay="closeModal"
    @click:close="closeModal"
  >
    <AppText
      name="body2"
      color="slate-700"
    >
      Revoke token "{{ refToken?.name }}"? Applications using it will lose access immediately.
    </AppText>

    <template #controls>
      <BtnPrimary
        text="Revoke"
        color="red"
        :disabled="refIsLoading"
        @click="confirmDelete"
      />
      <BtnSecondary
        text="Cancel"
        @click="closeModal"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalDeleteApiToken.scss" />
